import styled from "styled-components";

export const TitleContainer = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: space-between;
  width: 100%;
  height: 40px;

  >.left-side {
    flex: 1;
  }
 
  >.center-side {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .type-switch-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 5px 3px;
      border-radius: 8px;
      background-color: #424242;

      .type-switch-button {
        min-width: 40px;
        border: none;
        border-radius: 5px;
        background-color: transparent;
        padding: 4px 20px;
        margin: 0 2px;
        font-size: 14px;
        font-weight: 800;
        color: #1fbdcb;
        cursor: pointer;
        transition: color 0.3s, background-color 0.3s;

        &.active {
          background-color: #1fbdcb;
          color: #f0f0f0;
        }
      }
    }
  }

  >.right-side {
    flex: 1;
  }
`;

export const NewTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  text-align: start;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Title = styled.div`
  /* border: 1px solid black; */
  font-size: 20px;
  font-weight: bold;
  text-align: start;
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const VideoCount = styled.div`
  /* border: 1px solid black; */
  font-size: 12px;
  text-align: start;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(19.2%, 19.2%));
  /* grid-template-rows: 10vw 10vw; */
  column-gap: 10px;
  row-gap: 10px;
`;

export const PaginationContainer = styled.div`
  padding: 20px 100px;
  @media screen and (max-width : 415px){
    padding: 40px;
  }
`;
export const MyVideoContainer = styled.div`
  max-width : 1100px;
  width: 100%;
  height: 100%;
  margin: auto;
`

export const MyVideoRoot = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
`